<template>
    <div>
        <loading
            :active.sync="loadingContentProduct"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a @click="$router.go(-1)" class="headerButton">
                    <!-- <router-link :to="{name:'home'}" class="headerButton"> -->
                    <ion-icon name="chevron-back-outline"></ion-icon>
                    <!-- </router-link> -->
                </a>
            </div>
            <div class="pageTitle">
                {{
                    data_product_selected.pascabayar_category.product_name != ''
                        ? data_product_selected.pascabayar_category.product_name
                        : 'Loading...'
                }}
            </div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- elemet input  -->
            <div class="section inset mt-2">
                <div class="form-group boxed p-0 mb-2">
                    <div class="input-wrapper">
                        <label
                            class="label"
                            v-if="
                                data_product_selected.label_input == '' ||
                                data_product_selected.label_input == null ||
                                data_product_selected.label_input == undefined
                            "
                            >ID Pelanggan</label
                        >
                        <label class="label" v-else>{{
                            data_product_selected.label_input
                        }}</label>

                        <input
                            type="tel"
                            class="form-control form-control-lg"
                            v-if="data_product_selected.type_input == 'NUMBER'"
                            v-model="data_check.no_pelanggan"
                            @input="clearData"
                        />
                        <input
                            type="text"
                            class="form-control form-control-lg"
                            v-else
                            v-model="data_check.no_pelanggan"
                            @input="clearData"
                        />

                        <i class="clear-input">
                            <ion-icon
                                name="close-circle"
                                @click="clearData()"
                            ></ion-icon>
                        </i>
                    </div>

                    <div class="mt-1">
                        <div
                            class="chip chip-media"
                            style="font-size: 11px; background: #efefef"
                            @click="openPhoneBook()"
                        >
                            <i class="chip-icon bg-primary">
                                <ion-icon name="journal-outline"></ion-icon>
                            </i>
                            <span class="chip-label">Kontak</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Element Produk Dipilih -->
            <div class="section full mt-1">
                <ul class="listview image-listview inset">
                    <li>
                        <div class="item">
                            <img
                                v-lazyload
                                v-if="
                                    data_product_selected.icon != '' ||
                                    data_product_selected.icon != null
                                "
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="
                                    data_product_selected.icon != ''
                                        ? VUE_ENV.VUE_APP_ASSET_URL +
                                          '/img/icon/operator/' +
                                          data_product_selected.icon
                                        : require('@/assets/Loader-2.png')
                                "
                                alt="image"
                                class="image"
                            />
                            <div class="in">
                                <div>
                                    <b>{{
                                        data_product_selected.product_name
                                    }}</b>
                                    <footer>
                                        {{ data_product_selected.description }}
                                    </footer>
                                </div>
                                <span
                                    class="text-warning text-right"
                                    v-if="data_product_selected.points > 0"
                                    >+{{
                                        data_product_selected.points
                                    }}
                                    points</span
                                >
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- element biaya outlet -->
            <div
                class="section inset mt-1"
                v-if="
                    data_product_selected.status_biaya_outlet && !detail_tagihan
                "
            >
                <div class="form-group boxed">
                    <label class="label">Biaya Outlet</label>
                    <select
                        class="form-control custom-select"
                        v-model="data_check.biaya_outlet"
                        @change="clearData"
                    >
                        <option value="0">Rp 0</option>
                        <option value="500">Rp 500</option>
                        <option value="1000">Rp 1.000</option>
                        <option value="2000">Rp 2.000</option>
                        <option value="2500">Rp 2.500</option>
                        <option value="3000">Rp 3.000</option>
                        <option value="4000">Rp 4.000</option>
                        <option value="5000">Rp 5.000</option>
                        <option value="7000">Rp 7.000</option>
                        <option value="10000">Rp 10.000</option>
                        <option value="15000">Rp 15.000</option>
                    </select>
                    <div
                        class="alert alert-grey-custom mt-1"
                        style="
                            line-height: 1rem;
                            font-size: 11px;
                            text-align: justify;
                            padding: 10px 15px;
                        "
                    >
                        Biaya outlet adalah biaya tambahan yang dapat kamu
                        tentukan sendiri yang dimana akan menjadi keuntungan
                        langsung untuk kamu diluar dari fee yang telah
                        diberikan.
                    </div>
                </div>
            </div>

            <!-- button check tagihan -->
            <div class="section inset mt-1">
                <div class="form-group basic mt-1" v-if="!detail_tagihan">
                    <button
                        class="btn btn-primary btn-lg btn-block"
                        @click="checkbill(data_product_selected.product_id)"
                    >
                        Cek Tagihan
                    </button>
                </div>
            </div>

            <!-- detail tagihan  -->
            <div class="section inset mt-2" v-if="detail_tagihan">
                <div class="wide-block pt-2 pb-2">
                    <blockquote class="blockquote p-1 mb-1">
                        <h5 class="mb-0 ml-1">Informasi Tagihan</h5>
                    </blockquote>
                    <div
                        class=""
                        style="
                            border-bottom: 2px dashed #dee2e6;
                            padding-bottom: 10px;
                        "
                    >
                        <table style="font-size: 12px">
                            <tr>
                                <td width="130px">No. Pelanggan</td>
                                <td width="20px">:</td>
                                <td>{{ data_check.no_pelanggan }}</td>
                            </tr>
                            <tr>
                                <td width="130px">Nama</td>
                                <td width="20px">:</td>
                                <td>{{ data_detail.nama_pelanggan }}</td>
                            </tr>
                            <tr>
                                <td width="130px">Jml. Periode</td>
                                <td width="20px">:</td>
                                <td>
                                    {{ data_detail.bill_count_periode }} Periode
                                </td>
                            </tr>
                            <tr>
                                <td width="130px">Bulan/Tahun</td>
                                <td width="20px">:</td>
                                <td>{{ data_detail.bill_periode }}</td>
                            </tr>
                            <tr>
                                <td width="130px">Jml. Tagihan</td>
                                <td width="20px">:</td>
                                <td>
                                    Rp {{ data_detail.bill_tagihan | rupiah }}
                                </td>
                            </tr>
                            <tr>
                                <td width="130px">Admin Bank</td>
                                <td width="20px">:</td>
                                <td>
                                    Rp {{ data_detail.bill_admin | rupiah }}
                                </td>
                            </tr>
                            <!-- <tr v-if="data_product_selected.status_biaya_outlet">
                <td width="130px">Biaya Outlet</td>
                <td width="20px">:</td>
                <td>Rp {{ data_detail.biaya_outlet | rupiah }}</td>
              </tr>
              <tr>
                <td width="130px">Total Tagihan</td>
                <td width="20px">:</td>
                <td>
                  <b>Rp {{ data_detail.jumlah_bayar | rupiah }}</b>
                </td>
              </tr> -->
                        </table>
                    </div>
                    <div
                        class="mt-1"
                        style="
                            border-bottom: 2px dashed #dee2e6;
                            padding-bottom: 10px;
                        "
                        v-if="detail_tagihan && data_detail.bill_detail != ''"
                    >
                        <table
                            style="font-size: 12px"
                            v-if="
                                detail_tagihan && data_detail.bill_detail != ''
                            "
                        >
                            <tr
                                v-for="(item, index) in data_detail.bill_detail"
                                :key="index"
                            >
                                <td width="130px">{{ item.key }}</td>
                                <td width="20px">:</td>
                                <td>{{ item.value }}</td>
                            </tr>
                        </table>
                    </div>

                    <div
                        class="mt-1"
                        style="
                            border-bottom: 2px dashed #dee2e6;
                            padding-bottom: 10px;
                        "
                    >
                        <blockquote class="blockquote p-1 mt-2 mb-1">
                            <h5 class="mb-0 ml-1">Informasi Pembayaran</h5>
                        </blockquote>

                        <table style="font-size: 12px">
                            <tr>
                                <td width="130px">Metode</td>
                                <td width="20px">:</td>
                                <td>Saldo Akun</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    Total Tagihan
                                </td>
                                <td width="20px">:</td>
                                <td>
                                    Rp
                                    {{
                                        data_detail.bill_total_tagihan | rupiah
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    Diskon Promo
                                </td>
                                <td width="20px">:</td>
                                <td class="text-success">
                                    <span
                                        v-if="data_detail.bill_sharing_fee > 0"
                                    >
                                        - Rp
                                        {{
                                            data_detail.bill_sharing_fee
                                                | rupiah
                                        }}
                                    </span>
                                    <span v-else> Rp 0 </span>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    Total Bayar
                                </td>
                                <td width="20px">:</td>
                                <td>
                                    <b
                                        >Rp
                                        {{
                                            data_detail.bill_total_bayar
                                                | rupiah
                                        }}</b
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    Collection Fee
                                </td>
                                <td width="20px">:</td>
                                <td>
                                    <span
                                        v-if="
                                            data_detail.bill_collection_fee > 0
                                        "
                                    >
                                        Rp
                                        {{
                                            data_detail.bill_collection_fee
                                                | rupiah
                                        }}
                                    </span>
                                    <span v-else> Rp 0 </span>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    Cashback
                                </td>
                                <td width="20px">:</td>
                                <td>
                                    <span>
                                        Rp
                                        {{ data_detail.cashback | rupiah }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    Points
                                </td>
                                <td width="20px">:</td>
                                <td class="text-warning">
                                    +{{ data_detail.points | rupiah }} points
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div class="mt-1">
                        <table style="font-size: 12px">
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    Biaya Outlet
                                </td>
                                <td width="20px">:</td>
                                <td style="display: inline-flex">
                                    Rp {{ data_detail.biaya_outlet | rupiah }}
                                </td>
                            </tr>
                        </table>

                        <div
                            class="alert alert-grey-custom mt-1 mb-1 pt-2 pb-2"
                            role="alert"
                            style="background: rgba(237, 237, 241, 0.5)"
                        >
                            <div
                                class="alert-custom-container pb-1"
                                style="border-bottom: 1px dashed #c5c9ce"
                            >
                                <div class="alert-custom-description">
                                    <b>Total Bayar Pelanggan</b>
                                </div>
                                <span
                                    style="
                                        font-size: 16px;
                                        color: #17273e;
                                        font-weight: 700;
                                    "
                                >
                                    Rp {{ data_detail.jumlah_bayar | rupiah }}
                                </span>
                            </div>
                            <div class="mt-1">
                                <small
                                    ><i
                                        >*) Potensi Keuntungan dari Penjualan ke
                                        Pelanggan sebesar
                                        <b class="text-success"
                                            >Rp
                                            {{
                                                (data_detail.bill_sharing_fee +
                                                    data_detail.biaya_outlet +
                                                    data_detail.bill_collection_fee)
                                                    | rupiah
                                            }}</b
                                        ></i
                                    ></small
                                >
                            </div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-6">
                            <button
                                class="btn btn-secondary btn-block"
                                @click="clearData"
                            >
                                Batal
                            </button>
                        </div>
                        <div class="col-6">
                            <button
                                class="btn btn-primary btn-block"
                                @click="confirmation"
                            >
                                Bayar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- konfirmasi pembayaran -->
        <action-sheet
            ref="confirmation"
            :title="'Konfirmasi Pembayaran'"
            :inset="false"
        >
            <!-- Alert saldo tidak cukup -->
            <div v-if="customer.balance < data_detail.bill_total_bayar">
                <div
                    class="alert alert-danger-custom mb-1 pt-2 pb-2"
                    role="alert"
                >
                    <div class="alert-custom-container">
                        <div class="alert-custom-description">
                            <b
                                >Saldo kurang! Sisa Rp
                                {{ customer.balance | rupiah }}</b
                            >
                        </div>
                        <span class="text-muted">
                            <button
                                class="btn btn-warning btn-sm rounded shadowed pl-3 pr-3 text-nowrap"
                                style="font-size: 12px; height: 30px"
                                @click="redirectDepositPage()"
                            >
                                Isi Saldo
                            </button>
                        </span>
                    </div>
                </div>
            </div>

            <!-- infor harga beli -->
            <div style="border-bottom: 1px dashed #dee2e6" class="pb-1">
                <div
                    class="alert alert-grey-custom mb-1 pt-2 pb-2"
                    role="alert"
                >
                    <div class="alert-custom-container">
                        <div class="alert-custom-description">
                            <b>Total Pembayaran</b>
                        </div>
                        <span
                            style="
                                font-size: 16px;
                                color: #17273e;
                                font-weight: 700;
                            "
                        >
                            Rp {{ data_detail.bill_total_bayar | rupiah }}
                        </span>
                    </div>
                </div>
            </div>
            <div
                style="border-bottom: 1px dashed #dee2e6"
                class="text-standar mt-1 mb-1 pb-1"
            >
                <span>
                    Dengan membayar di {{ VUE_ENV.VUE_APP_NAME }}, saya setuju
                    dengan <b>syarat</b> dan <b>ketentuan</b>
                    {{ VUE_ENV.VUE_APP_NAME }}
                </span>
            </div>

            <div class="form-group basic">
                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-secondary btn-block btn-lg"
                            @click="hideConfirm"
                        >
                            Batal
                        </button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader
                            :loading="loadingButton"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            @click.native="verifyWithOutPin()"
                            :disabled="
                                customer.balance < data_detail.bill_total_bayar
                            "
                            v-if="customer.pin_trx == 'DISABLED'"
                            >Bayar</ButtonLoader
                        >
                        <button
                            class="btn btn-primary btn-block btn-lg"
                            @click="verifyWithPin()"
                            :disabled="
                                customer.balance < data_detail.bill_total_bayar
                            "
                            v-else
                        >
                            Bayar
                        </button>
                    </div>
                </div>
            </div>
        </action-sheet>

        <!-- Modal Status Pembayaran  -->
        <action-sheet ref="status" :title="'Status Pembayaran'" :inset="true">
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Pembayaran Berhasil</h3>
                <p>Transaksi Anda sedang diproses</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block btn-lg"
                    @click="directToHistory()"
                >
                    Lihat Riwayat Transaksi
                </button>
                <button
                    class="btn btn-outline-primary btn-block btn-lg"
                    @click="status('hide')"
                >
                    Kembali
                </button>
            </div>
        </action-sheet>

        <Dialog
            ref="dialog_update_apk"
            :loading="false"
            :title="'Update Aplikasi'"
            @confirm="updateApk()"
        >
            Aplikasi versi terbaru telah tersedia di playstore. Update Sekarang!
        </Dialog>
    </div>
</template>
<script>
    import $axios from './../../../api.js';
    import { mapState, mapMutations } from 'vuex';
    export default {
        props: ['product_selected', 'toast_reference'],
        data() {
            return {
                loadingButton: false,
                loadingContentProduct: true,
                detail_tagihan: false,
                countInquiry: 0,
                status_biaya_outlet: 1,
                product: [],
                data_detail: {
                    invoice: '',
                    nama_pelanggan: '',
                    bill_count_periode: '',
                    bill_periode: '',
                    bill_tagihan: '',
                    bill_admin: '',
                    bill_total_tagihan: '',
                    bill_sharing_fee: '',
                    bill_collection_fee: '',
                    bill_total_bayar: '', // Total Bayar Mitra
                    bill_detail: '',
                    biaya_outlet: '',
                    jumlah_bayar: '', // Jumlah Bayar pelanggan
                    cashback: '0',
                    points: '0',
                },
                keywords: '',
                time: null,
            };
        },
        created() {
            // window.fbq('track', 'ViewContent');
            setTimeout(() => (this.loadingContentProduct = false), 100);
        },
        computed: {
            ...mapState(['customer', 'toast', 'VUE_ENV']),
            ...mapState('transactionPascabayar', {
                data_check: state => state.data_check,
                data_payment: state => state.data_payment,
                data_product_selected: state => state.data_product_selected,
            }),
        },
        methods: {
            ...mapMutations('transactionPascabayar', [
                'RESET_DATA_CHECK',
                'RESET_DATA_PAYMENT',
                'SET_DATA_PRODUCT_SELECTED',
            ]),
            updateApk() {
                this.dialogUpdateAPK('hide');
                window.open(
                    'https://play.google.com/store/apps/details?id=com.digifazz.app',
                    '_blank'
                );
            },
            dialogUpdateAPK(value) {
                let element = this.$refs.dialog_update_apk.$el;
                window.$(element).modal(value);
            },
            filterProduct: function (product) {
                var app = this;
                return product.filter(function (item) {
                    let regex = new RegExp('(' + app.keywords + ')', 'i');
                    return item.product_name.match(regex);
                });
            },
            clearData() {
                this.$store.commit('RESET_TOAST');
                this.detail_tagihan = false;
                this.RESET_DATA_PAYMENT();
                this.data_detail = {
                    invoice: '',
                    nama_pelanggan: '',
                    bill_count_periode: '',
                    bill_periode: '',
                    bill_tagihan: '',
                    bill_total_tagihan: '',
                    bill_sharing_fee: '',
                    bill_collection_fee: '',
                    bill_total_bayar: '',
                    bill_detail: '',
                    biaya_outlet: '',
                    jumlah_bayar: '',
                    cashback: '',
                    points: '',
                };
            },
            checkInquiryBill() {
                this.countInquiry = this.countInquiry + 1;
                if (
                    this.detail_tagihan == false &&
                    this.loadingContentProduct == true &&
                    this.countInquiry <= 5
                ) {
                    $axios
                        .get(
                            '/transaction/pascabayar/' +
                                this.data_payment.invoice
                        )
                        .then(response => {
                            if (response.data.data.nama_pelanggan != null) {
                                this.detail_tagihan = true;
                                this.loadingContentProduct = false;
                                this.data_payment.invoice =
                                    response.data.data.bill_invoice;
                                this.data_detail = {
                                    invoice: response.data.data.bill_invoice,
                                    nama_pelanggan:
                                        response.data.data.nama_pelanggan,
                                    // bill_periode: response.data.data.bill_periode.split(",").length,
                                    bill_count_periode:
                                        response.data.data.bill_count_periode,
                                    bill_periode:
                                        response.data.data.bill_periode,
                                    bill_tagihan:
                                        response.data.data.bill_tagihan,
                                    bill_admin: response.data.data.bill_admin,
                                    bill_total_tagihan:
                                        response.data.data.bill_total_tagihan,
                                    bill_sharing_fee:
                                        response.data.data.bill_sharing_fee,
                                    bill_collection_fee:
                                        response.data.data.bill_collection_fee,
                                    bill_total_bayar:
                                        response.data.data.bill_total_bayar,
                                    cashback: response.data.data.cashback,
                                    points: response.data.data.points,
                                    bill_detail: JSON.parse(
                                        response.data.data.bill_detail
                                    ),
                                };
                            } else {
                                setTimeout(() => this.checkInquiryBill(), 3000);
                            }
                        })
                        .catch(e => {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.message,
                                tipe: 'default',
                                position: 'top',
                            });
                            this.loadingContentProduct = false;
                        });
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message:
                            'Tagihan tidak tersedia, silahkan hubungi Admin',
                        tipe: 'default',
                        position: 'top',
                    });
                    this.loadingContentProduct = false;
                }
            },
            checkbill(product_id) {
                const label_input =
                    this.data_product_selected.label_input != null
                        ? this.data_product_selected.label_input
                        : 'ID Pelanggan';

                this.countInquiry = 0;
                this.$store.commit('RESET_TOAST');
                this.detail_tagihan = false;
                this.loadingContentProduct = true;
                this.data_check.product_id = product_id;
                if (this.data_check.no_pelanggan != '') {
                    $axios
                        .post('/pascabayar/checkbill', this.data_check)
                        .then(response => {
                            this.data_payment.invoice =
                                response.data.data.invoice;
                            if (
                                response.data.data.nama_pelanggan != undefined
                            ) {
                                this.detail_tagihan = true;
                                this.loadingContentProduct = false;
                                this.data_detail = {
                                    invoice: response.data.data.invoice,
                                    nama_pelanggan:
                                        response.data.data.nama_pelanggan,
                                    bill_count_periode:
                                        response.data.data.jumlah_periode,
                                    bill_periode: response.data.data.periode,
                                    bill_tagihan:
                                        response.data.data.jumlah_tagihan,
                                    bill_admin: response.data.data.biaya_admin,
                                    bill_total_tagihan:
                                        response.data.data.total_tagihan,
                                    bill_sharing_fee:
                                        response.data.data.sharing_fee,
                                    bill_collection_fee:
                                        response.data.data.collection_fee,
                                    bill_total_bayar:
                                        response.data.data.total_bayar_mitra,
                                    bill_detail: response.data.data.detail,
                                    biaya_outlet:
                                        response.data.data.biaya_outlet,
                                    cashback: response.data.data.cashback,
                                    points: response.data.data.points,
                                    jumlah_bayar:
                                        response.data.data
                                            .jumlah_bayar_pelanggan,
                                };
                            } else {
                                this.checkInquiryBill();
                            }
                        })
                        .catch(e => {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.data.description,
                                tipe: 'default',
                                position: 'top',
                                icon: 'danger',
                            });
                            this.loadingContentProduct = false;
                        });
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message: label_input + ' tidak boleh kosong',
                        tipe: 'default',
                        position: 'top',
                        icon: 'danger',
                    });
                    this.loadingContentProduct = false;
                }
            },
            confirmation() {
                this.$store.commit('RESET_TOAST');
                let element = this.$refs.confirmation.$el;
                window.$(element).modal('show');
            },
            hideConfirm() {
                let element = this.$refs.confirmation.$el;
                window.$(element).modal('hide');
            },
            status(value) {
                let element = this.$refs.status.$el;
                window.$(element).modal(value);
            },
            verifyWithOutPin() {
                this.loadingButton = true;
                $axios
                    .post('/pascabayar/paybill', {
                        invoice: this.data_payment.invoice,
                    })
                    .then(() => {
                        this.loadingButton = false;
                        this.hideConfirm();
                        this.status('show');
                        this.RESET_DATA_CHECK();
                        this.clearData();
                        this.data_check.no_pelanggan = '';
                    })
                    .catch(e => {
                        this.hideConfirm();
                        this.loadingButton = false;
                        if (
                            e.response.status == 400 &&
                            e.response.data.responseCode == 'AVAILABLE_UPDATE'
                        ) {
                            this.dialogUpdateAPK('show');
                        } else {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        }
                    });
            },
            verifyWithPin() {
                this.hideConfirm();
                this.$router.push({
                    name: 'auth.pin.verify',
                    params: {
                        data_reference: this.data_payment,
                        url_reference: '/pascabayar/paybill',
                        previous_page_reference: 'pascabayar-order',
                        params_previous_page_reference: {
                            id: this.data_product_selected.id, // produk id
                            product_selected: this.data_product_selected, // produk detail
                        },
                        next_page_reference: 'pascabayar-order',
                        params_next_page_reference: {
                            id: this.data_product_selected.id, // operator id
                            product_selected: this.data_product_selected, // kategori name
                        },
                    },
                });
                this.RESET_DATA_CHECK();
                this.RESET_DATA_PAYMENT();
            },
            phone(phone) {
                this.data_check.no_pelanggan =
                    this.$options.filters.filterPhone(
                        this.$options.filters.filterPhone(
                            phone.substring(0, 3),
                            ['+62', '62'],
                            ['0', '0']
                        ) + phone.substring(20, 3),
                        ['-'],
                        ['']
                    );
            },
            openPhoneBook() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.openPhoneBook();
                }
            },
            redirectDepositPage() {
                this.hideConfirm();
                this.$router.push({ name: 'deposit' });
            },
            directToHistory() {
                this.status('hide');
                this.$router.push({
                    name: 'transaction.index',
                });
            },
        },
        mounted() {
            if (this.product_selected == undefined) {
                this.$router.go(-1);
            } else {
                this.SET_DATA_PRODUCT_SELECTED(this.product_selected);
            }

            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    if (
                        this.toast_reference.show &&
                        this.toast_reference.icon == 'success'
                    ) {
                        this.status('show');
                    } else {
                        this.$store.commit('SET_TOAST', this.toast_reference);
                    }
                }
            }, 500);

            window['phone'] = phone => {
                this.phone(phone);
            };
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
            this.RESET_DATA_CHECK();
            this.RESET_DATA_PAYMENT();
        },
        filters: {
            filterPhone: function (value, findArray, replaceArray) {
                var i,
                    regex = [],
                    map = {};
                for (i = 0; i < findArray.length; i++) {
                    regex.push(
                        findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1')
                    );
                    map[findArray[i]] = replaceArray[i];
                }
                regex = regex.join('|');
                var destination = value.replace(
                    new RegExp(regex, 'g'),
                    function (matched) {
                        return map[matched];
                    }
                );
                return destination.replace(/ /g, '');
            },
        },
    };
</script>
